/**
 * @file supportData.js
 * @description FAQ, 문의하기, 개인정보 동의 영역에서 사용하는 지원 데이터를 정의합니다.
 * @used-in pages/FaqPage.jsx, pages/ContactPage.jsx, hooks/useContactForm.js
 * @migrated-from src/App.js
 */

export const faqItems = [
  {
    question: '제약·화장품 산업 외 다른 제조업에도 구축이 가능한가요?',
    answer:
      '현재 홈페이지에서는 제약·화장품 산업 중심으로 소개하고 있지만, 제조 현장의 추적성과 표준 작업이 중요한 환경이라면 요구사항 검토 후 적용 범위를 함께 논의할 수 있습니다.',
  },
  {
    question: 'RWS, MES, WMS를 각각 개별 도입할 수 있나요?',
    answer:
      '가능합니다. 현장의 우선순위와 예산, 일정에 맞춰 필요한 영역부터 단계적으로 도입하고 이후 연계 확장까지 고려한 방식으로 제안드립니다.',
  },
  {
    question: '유지보수는 어떤 방식으로 지원되나요?',
    answer:
      '문의 접수 후 내용을 분류하고, 원격 대응이 가능한 항목은 우선 조치하며 필요 시 현장 지원을 병행합니다. 조치 결과와 후속 권고사항도 함께 안내드립니다.',
  },
  {
    question: '도입 전 데모 또는 상담이 가능한가요?',
    answer:
      '문의하기 페이지를 통해 회사명과 담당자 정보를 남겨주시면, 요구사항 확인 후 적합한 상담 일정과 데모 범위를 안내드립니다.',
  },
];

export const inquirySeed = [
  { id: 'inq-001', title: 'RWS 도입 상담 요청', company: '에이치케이바이오', date: '2026.04.18', status: '접수완료' },
  { id: 'inq-002', title: 'MES 구축 범위 문의', company: '코스메랩', date: '2026.04.14', status: '검토중' },
  { id: 'inq-003', title: '유지보수 프로세스 문의', company: '신한제약', date: '2026.04.09', status: '답변완료' },
];

export const inquiryTypes = ['견적문의', '유지보수', '기타'];

export const privacyPolicyText =
  '문의 접수 및 답변 안내를 위해 회사명, 담당자명, 연락처, 이메일 등 입력하신 정보를 수집합니다. 수집된 정보는 문의 대응 목적에 한하여 사용되며, 관련 법령 또는 내부 기준에 따라 안전하게 관리됩니다. 이용자는 개인정보 수집 및 이용 동의를 거부할 수 있으나, 이 경우 문의 접수가 제한될 수 있습니다.';
